import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "button"]

  connect() {
    this.isOpen = false
    // 外部クリックを検知するためのイベントリスナー
    document.addEventListener("click", this.handleOutsideClick.bind(this))
  }

  disconnect() {
    document.removeEventListener("click", this.handleOutsideClick.bind(this))
  }

  toggle() {
    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.isOpen = true
    this.menuTarget.classList.remove("hidden")
    this.buttonTarget.setAttribute("aria-expanded", "true")

    // アニメーション効果
    setTimeout(() => {
      this.menuTarget.classList.remove("transform", "opacity-0", "scale-95")
      this.menuTarget.classList.add("transform", "opacity-100", "scale-100")
    }, 10)
  }

  close() {
    this.isOpen = false
    this.buttonTarget.setAttribute("aria-expanded", "false")

    // アニメーション効果
    this.menuTarget.classList.remove("transform", "opacity-100", "scale-100")
    this.menuTarget.classList.add("transform", "opacity-0", "scale-95")

    setTimeout(() => {
      this.menuTarget.classList.add("hidden")
    }, 100)
  }

  // 外部クリックで閉じる
  handleOutsideClick(event) {
    if (this.isOpen && !this.element.contains(event.target)) {
      this.close()
    }
  }

  // ESCキーで閉じる
  handleKeydown(event) {
    if (event.key === "Escape" && this.isOpen) {
      this.close()
    }
  }
}
